import { DraftTypes, GradingWorkflowSettingsTypeKeys, WorkflowSettingsTabs } from './types';

export const workflowSettingsTabs: WorkflowSettingsTabs = {
    QUESTION_WEIGHTS: {
        index: 0,
        name: 'grading.threshold.tabs.questionWeights',
        group: GradingWorkflowSettingsTypeKeys.WEIGHTS_AND_THRESHOLDS,
        acquiresLock: true,
        draftType: DraftTypes.WEIGHTS_AND_THRESHOLDS,
    },
    VALUES: {
        index: 1,
        name: 'grading.threshold.tabs.values',
        group: GradingWorkflowSettingsTypeKeys.WEIGHTS_AND_THRESHOLDS,
        acquiresLock: true,
        draftType: DraftTypes.WEIGHTS_AND_THRESHOLDS,
        tabHiddenIfMarksOnly: true,
    },
    REVIEW: {
        index: 2,
        name: 'grading.threshold.tabs.review',
        group: GradingWorkflowSettingsTypeKeys.WEIGHTS_AND_THRESHOLDS,
        acquiresLock: false,
        draftType: DraftTypes.WEIGHTS_AND_THRESHOLDS,
        tabHiddenIfMarksOnly: true,
    },
    QUESTION_ASSIGNMENTS: {
        index: 0,
        name: 'grading.settingsWorkflow.tabs.assignments',
        group: GradingWorkflowSettingsTypeKeys.QUESTION_ASSIGNMENTS,
        acquiresLock: true,
        draftType: DraftTypes.QUESTION_ASSIGNMENTS,
    },
    QUESTION_ANSWER_KEYS: {
        index: 0,
        name: 'grading.settingsWorkflow.tabs.answerKeys',
        group: GradingWorkflowSettingsTypeKeys.QUESTION_ANSWER_KEYS,
        acquiresLock: true,
        draftType: DraftTypes.QUESTION_ANSWER_KEYS,
    },
};

export enum QuestionAccessLevel {
    VIEW_ALL_MARK_ALL = 'view_all_mark_all',
    VIEW_ALL_MARK_OWN = 'view_all_mark_own',
    VIEW_OWN_MARK_OWN = 'view_own_mark_own',
}

export enum QuestionAssignmentEditLevel {
    PLANNERS_ONLY = 'planners_only',
    PLANNERS_AND_GRADERS = 'planners_and_graders',
}

export enum GradingWorkflowAllocationUnit {
    QUESTION = 'QUESTION',
    SUBMISSION = 'SUBMISSION',
}

const readAccessOptions = [
    { key: 1, value: QuestionAccessLevel.VIEW_ALL_MARK_ALL, text: 'grading.questionAssignments.subFeature.gradersViewAllMarkAll' },
    { key: 2, value: QuestionAccessLevel.VIEW_ALL_MARK_OWN, text: 'grading.questionAssignments.subFeature.gradersViewAllMarkOwn' },
    { key: 3, value: QuestionAccessLevel.VIEW_OWN_MARK_OWN, text: 'grading.questionAssignments.subFeature.gradersViewOwnMarkOwn' },
];

const editAccessOptions = [
    { key: 1, value: QuestionAssignmentEditLevel.PLANNERS_AND_GRADERS, text: 'grading.questionAssignments.subFeature.plannersAndGradersAssign' },
    { key: 2, value: QuestionAssignmentEditLevel.PLANNERS_ONLY, text: 'grading.questionAssignments.subFeature.plannersAssign' },
];

export { readAccessOptions, editAccessOptions };

export enum CompositeCalculationRule {
    IELTS_COMPOSITE_GRADE_V1 = 'ielts_composite_grade_v1',
    MOJ_COMPOSITE_GRADE_V1 = 'moj_composite_grade_v1',
    ASSESSMENT_PATH_TOTAL_POINTS_V1 = 'assessment_path_total_points_v1',
    ASSESSMENT_PATH_WEIGHTED_POINTS_V1 = 'assessment_path_weighted_points_v1',
    MULTIPLE_ATTEMPTS_HIGHEST_GRADE_V1='multiple_attempts_highest_grade_v1',
    MULTIPLE_ATTEMPTS_AVERAGE_GRADE_V1='multiple_attempts_average_grade_v1',
    MULTIPLE_ATTEMPTS_LATEST_GRADE_V1='multiple_attempts_latest_grade_v1',
}
